export default "__VITE_ASSET__044a69b5__"